import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import { farmers } from "../../config/images";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import translations from "../../config/language";


const mapContainerStyle = {
    height: "100vh",
};

const LocationDetails = ({ selectedFarmer }) => {

    const [isGalleryOpen, setIsGalleryOpen] = useState(false);

    // Sample coordinates (Replace with actual farmer coordinates)
    const latitude = 38.8951;
    const longitude = -77.0364;

    const googleMapsApiKey = "AIzaSyAhALM3q3fyD_1T7sHMd2kSXwHAUSbSvf0&libraries=places"; // Replace with your API Key
    const [zoom, setZoom] = useState(5);
const [imageIndex, setImageIndex] = useState(0);

    const mapOptions = {
        mapTypeId: "satellite",
        disableDefaultUI: true,
        zoomControl: true,
    };

    const handleGalleryClose = () => {
        setIsGalleryOpen(false);
    };

    const galleryImages = [
        farmers.galleryImage1,
        farmers.galleryImage2,
        farmers.galleryImage3,
        farmers.galleryImage4,
    ]
    const language = process.env.REACT_APP_LANGUAGE;

    return (
        <div className="user-profile" >

            <Grid container>
                <Grid item lg={4} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", paddingLeft:"20px" }}
                >{translations[language].address}
                </Grid>
                <Grid item lg={8} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}>
                    {selectedFarmer.location}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].latitude}</Grid>
                <Grid item lg={5} className="grid-item" style={{ fontWeight: 700 }}>38.8951, 77.0364</Grid>
                <Grid item lg={3} className="grid-item" style={{ fontWeight: 700 }}>
                    <div style={{ display: "flex", gap: "10px", fontWeight: 700 }}>
                        <div >2.5 Hectors</div>
                        <img src={farmers.locationDetailsImage} alt="loaction-img"
                            className=""
                            onClick={() => setIsGalleryOpen(true)}
                            style={{ cursor: "pointer" }}
                        />
                    </div>

                </Grid>
            </Grid>

            <Box mt={2}>
                <LoadScript googleMapsApiKey={googleMapsApiKey}>
                    <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        center={{ lat: latitude, lng: longitude }}
                        zoom={zoom}
                        options={mapOptions}
                    >
                        <Marker position={{ lat: latitude, lng: longitude }}
                            onClick={() => setZoom(16)} />
                    </GoogleMap>
                </LoadScript>
            </Box>

            {isGalleryOpen &&
                <ImageGallery
                    images={galleryImages}
                    isOpen={isGalleryOpen}
                    onClose={handleGalleryClose}
                    imageIndex={imageIndex}
                />
            }
        </div>
    );
};

export default LocationDetails;
